import type { ApiModuleEndpoints } from '../types'

export const salesTableApiEndpoints = {
  list: {
    method: 'GET',
    path: '/sales-tables',
    requiresAuth: true,
  },
  options: {
    method: 'GET',
    path: '/sales-tables/options',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/sales-tables/:id',
    requiresAuth: true,
  },
  productCatalog: {
    method: 'GET',
    path: '/sales-tables/:id/product-catalog',
    requiresAuth: true,
  },
  create: {
    method: 'POST',
    path: '/sales-tables',
    requiresAuth: true,
  },
  importTemplate: {
    method: 'GET',
    path: '/sales-tables/import-template',
    requiresAuth: true,
  },
  importCatalogs: {
    method: 'GET',
    path: '/sales-tables/import-catalogs',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/sales-tables/:id',
    requiresAuth: true,
  },
  delete: {
    method: 'DELETE',
    path: '/sales-tables/:id',
    requiresAuth: true,
  },
  restore: {
    method: 'POST',
    path: '/sales-tables/:id/restore',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
